import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home';
import RentalsPage from './pages/RentalsPage';
import GetInvolvedPage from './pages/GetInvolvedPage';
import DonatePage from './pages/DonatePage';
import SummerSeriesPage from './pages/SummerSeriesPage';
import FestivalPage from './pages/FestivalPage';
import ContactPage from './pages/ContactPage';
import SupportersPage from './pages/SupportersPage';
import PressReleasesPage from './pages/PressReleasesPage';
import PressReleasePage from './pages/PressReleasePage';
import { Toaster } from './components/ui/sonner';
import { I18nProvider } from './contexts/I18nContext';
import { CMSPreviewProvider } from './contexts/CMSPreviewContext';
import ScrollToTop from './components/ScrollToTop';
import SkipLink from './components/SkipLink';
import LanguageDetectBanner from './components/LanguageDetectBanner';
import AdminApp from './admin/AdminApp';

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <I18nProvider>
          <CMSPreviewProvider>
            <BrowserRouter>
              <ScrollToTop />
              <SkipLink />
              <LanguageDetectBanner />
              <Routes>
                <Route path="/admin/*" element={<AdminApp />} />
                <Route path="/" element={<Home />} />
                <Route path="/rentals" element={<RentalsPage />} />
                <Route path="/get-involved" element={<GetInvolvedPage />} />
                <Route path="/donate" element={<DonatePage />} />
                <Route path="/summer-series" element={<SummerSeriesPage />} />
                <Route path="/festival" element={<FestivalPage />} />
                <Route path="/supporters" element={<SupportersPage />} />
                <Route path="/press-releases" element={<PressReleasesPage />} />
                <Route path="/press-releases/:slug" element={<PressReleasePage />} />
                <Route path="/contact" element={<ContactPage />} />
              </Routes>
            </BrowserRouter>
            <Toaster position="top-right" richColors />
          </CMSPreviewProvider>
        </I18nProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
